import Joyride from "react-joyride";
import { commonservices } from "../../services/CommonServices";

function CustomTooltip(props) {
  const {
    closeProps,
    continuous,
    index,
    primaryProps,
    skipProps,
    step,
    tooltipProps,
    size,
  } = props;
  return (
    <div
      className={`tour-content-main-inner ${step?.customProp?.classname}`}
      {...tooltipProps}
    >
      <div className="tour-inner-container">
        {step.title && <p className="tour-title">{step.title}</p>}
        <div className="tour-content">{step.content}</div>
        <div className="skip-next-img tour-container-footer">
          <div className="tour-step">
            {index + 1} of {size}
          </div>

          <div className="tour-footer-btn">
            <button className="tour-skip" {...skipProps}>
              Skip
            </button>

            {continuous && (
              <button className="tour-next" {...primaryProps}>
                {index + 1 === size ? "Done" : "Next"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const Walkthrough = ({ callback, steps, run, keyName }, ref) => {
  let walkthroughDetail = commonservices.getWalkthroughDetail();
  const handleJoyrideCallback = (data) => {
    const { status, type, step, action } = data;

    if (action === "skip") {
      if (callback) {
        if (walkthroughDetail) {
          walkthroughDetail[keyName] = true;
        } else {
          walkthroughDetail = { [keyName]: true };
        }
        commonservices.setItem(
          "walkthrough",
          JSON.stringify(walkthroughDetail)
        );
        callback();
      }
    }
    if (step?.title === "Workflow Manage" && ref?.current) {
      ref.current(); // Simulate a click on the referenced element
    }

    if (status === "finished" || type === "tour:end") {
      if (callback) {
        if (walkthroughDetail) {
          walkthroughDetail[keyName] = true;
        } else {
          walkthroughDetail = { [keyName]: true };
        }
        commonservices.setItem(
          "walkthrough",
          JSON.stringify(walkthroughDetail)
        );
        callback();
      }
    }
    const tooltip = document.querySelector(".react-joyride__spotlight");
    if (tooltip) {
      // const step = steps[currentStep];
      let element = document.querySelector(step.target);
      if (element) {
        if(step.className == "") {
          tooltip.style.width = `${step.width}`;
          tooltip.style.height = `${step.height}`;
          tooltip.style.transition = "all 0.3s ease";  
          let topValue = parseInt(window.getComputedStyle(tooltip).top, 10) || 0;
        tooltip.style.top = `${topValue + 5}px`;
        let leftValue =
          parseInt(window.getComputedStyle(tooltip).left, 10) || 0;
        tooltip.style.left = `${leftValue + 5}px`;
        }
        else {
          element.classList.add(step.className);
        element = document.querySelector(step.target);
        tooltip.style.width = `${element.offsetWidth}px`;
        tooltip.style.height = `${element.offsetHeight}px`;
        tooltip.style.transition = "all 0.3s ease";
        let topValue = parseInt(window.getComputedStyle(tooltip).top, 10) || 0;
        tooltip.style.top = `${topValue + 10}px`;
        let leftValue =
          parseInt(window.getComputedStyle(tooltip).left, 10) || 0;
        tooltip.style.left = `${leftValue + 10}px`;
        }                
      }
    }
  };

  return (
    <Joyride
      tooltipComponent={CustomTooltip}
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      hideBackButton={true}
      scrollToFirstStep={true}
      disableOverlayClose={true}
      scrollToSteps={true}
      scrollOffset={250}
      locale={{
        last: "Done",
        skip: "Skip",
        next: "Next",
      }}
      styles={{
        options: {
          zIndex: 1000,
        },
      }}
      callback={handleJoyrideCallback}
    />
  );
};

export default Walkthrough;
